import { createMuiTheme } from "@material-ui/core";
import { blue, green, red } from "@material-ui/core/colors";

export const primaryFontSize = 13

export const white = '#ffffff'
export const black = '#000000'
export const red400 = '#fe290c'
export const green400 = '#509518'
export const blue400 = '#1976d2'

const AppTheme = createMuiTheme({
    palette: {
        primary: {
          light: blue[500],
          main: blue[700],
          dark: blue[900],
          contrastText: white
        },
        secondary: {
          light: green[400],
          main: green[500],
          dark: green[900],
          contrastText: white
        }
    },
    typography: {
        fontFamily: [
          'Roboto',
          'Arial',
          'sans-serif'
        ].join(','),
        fontSize: primaryFontSize,
        fontWeightLight: 100,
        fontWeightRegular: 400,
        fontWeightBold: 700,
        body1: {
          fontSize: primaryFontSize
        },
        body2: {
          fontSize: primaryFontSize - 1
        }
      },
})

const AppSecondaryTheme = createMuiTheme({
  palette: {
      primary: {
        light: red[400],
        main: red[500],
        dark: red[900],
        contrastText: white
      },
      secondary: {
        light: red[400],
        main: red[500],
        dark: red[900],
        contrastText: white
      }
  },
  typography: {
      fontFamily: [
        'Roboto',
        'Arial',
        'sans-serif'
      ].join(','),
      fontSize: primaryFontSize,
      fontWeightLight: 100,
      fontWeightRegular: 400,
      fontWeightBold: 700,
      body1: {
        fontSize: primaryFontSize
      },
      body2: {
        fontSize: primaryFontSize - 1
      }
    },
})

export const Themes = {
  AppTheme,
  AppSecondaryTheme
}